import { MathUtils } from '../../../utils/math-utils';
import { Styled } from '../styled';

export const getItemsHeight = (elementsCount, forceShowChildren, maxElementsCount) => {
  if (elementsCount) {
    return MathUtils.clamp(
      (elementsCount + Number(forceShowChildren)) * Styled.ITEM_HEIGHT,
      Styled.ITEM_HEIGHT,
      maxElementsCount * Styled.ITEM_HEIGHT,
    );
  } else {
    return Styled.ITEM_HEIGHT;
  }
}